import { createRouterReducer } from '../lib/redux-router';

import history from '../history';

export default createRouterReducer(history);
